import { useEffect, useRef, useState } from 'react';
import Animated from 'react-native-reanimated';

import { RouteProp, useRoute, useScrollToTop } from '@react-navigation/native';

import { useActiveProductConfig } from '@/hooks/use-active-product';
import { CasinoLobbyStackParamList } from '@/navigation/casino/types';

import { FAVORITES_TAB_ID, FREE_SPINS_TAB_ID, LOBBY_TAB_ID } from '../utils/utils';

/**
 * Shared state of the casino lobby screen (route category, selected tab, list ref, maintenance flag),
 * used by both the native/mobile (`CasinoLobby.tsx`) and the web (`CasinoLobby.web.tsx`) screens.
 */
export const useCasinoLobbyScreen = () => {
    const productConfig = useActiveProductConfig();
    const { enabled: isMaintenanceEnabled } = productConfig?.appMaintenanceConfig?.primary || {};

    const route = useRoute<RouteProp<CasinoLobbyStackParamList, 'CasinoLobbyScreen'>>();
    const { category } = route.params || {};
    const isLobby = category === 'lobby' || !category;

    const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>('lobby');
    const listRef = useRef<Animated.ScrollView>(null);

    useScrollToTop(listRef);

    useEffect(() => {
        if (category === 'Free Spins') {
            setSelectedCategoryId(FREE_SPINS_TAB_ID);
        } else if (category === 'Favorites') {
            setSelectedCategoryId(FAVORITES_TAB_ID);
        } else if (!category || category === 'lobby') {
            setSelectedCategoryId(LOBBY_TAB_ID);
        }
    }, [category]);

    return { isMaintenanceEnabled, isLobby, category, selectedCategoryId, setSelectedCategoryId, listRef };
};
